/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol extends models.ServiceAccountCredentialsBaseForSaasAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForSaasAssumeRoleProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol>): ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol(), model);
        ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol>): ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.newInstance(<ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForSaasAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForSaasAwsAssumeRoleProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Role ARN. This is a required field.
     */
    assume_role_arn: string;

    /**
     * External ID configured in Assume Role. This is a required field.
     */
    assume_role_external_id: string;

    /**
     * Whether MFA enabled or not in Assume Role. This is a required field.
     */
    assume_role_mfa_enabled: boolean;

}
